export const AirportSettings = {
  namespaced: true,
  state: {
    gates: [],
    claims: [],
    statuses: []
  },
  mutations: {
    gates(state, gates) {
      state.gates = gates;
    },
    claims(state, claims) {
      state.claims = claims;
    },
    statuses(state, statuses) {
      state.statuses = statuses;
    }
  },
  getters: {
    gates: state => {
      return state.gates;
    },
    claims: state => {
      return state.claims;
    },
    statuses: state => {
      return state.statuses;
    },
    statusByKey: state => {
      const map = {};
      (state.statuses || []).forEach((status) => {
        if (status && status.key != null) {
          map[status.key] = status.name;
        }
      });
      return map;
    }
  }
};